var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{'sub-active': _vm.isCurrentRoute}},[_c('router-link',{attrs:{"to":{ name: _vm.route },"active-class":"sub-active"}},[_c('span',[_vm._v(_vm._s(_vm.icon))]),_c('a',{class:{'sub-active': _vm.isCurrentRoute},attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.label))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69d4df00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/sidemenu.vue
// module id = HFVJ
// module chunks = 110